import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import Joyride, { CallBackProps, Step } from "react-joyride";
import { ApplicationState } from "../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { markEmptyDataPeriodViewTourAsShown } from "../../../../store/tour/actions";
import { connect } from "react-redux";
import useUserRole from "../../../../utils/hooks/useUserRole";

type StateProps = {
  isTourShown?: boolean;
};
type DispatchProps = {
  markEmptyDataPeriodViewTourAsShown: () => any;
};

type Props = StateProps & DispatchProps;

const EmptyDataPeriodViewTour: FunctionComponent<Props> = (props) => {
  const steps: Step[] = useMemo(
    () => [
      {
        disableBeacon: true,
        target: "#addColumnTooltip tbody > tr:nth-child(1) > td:nth-child(2)",
        content: (
          <>
            Upload your assessment or screening data here as a CSV or XLSX file.
            Most formats are supported automatically, and you can define columns
            for any unsupported ones.
          </>
        ),
      },
      {
        disableBeacon: true,
        target: "#addColumnTooltip tbody > tr:nth-child(2)",
        content: (
          <>
            If you don’t have a file to upload, you can search for the assessment
            and enter results manually. You can also enter scores for behavior
            assessments or add behavior screener.
          </>
        ),
      },
      {
        disableBeacon: true,
        target: "#addColumnTooltip tbody > tr:nth-child(3)",
        content: (
          <>
            If you don’t have a file to upload, you can search for the assessment
            and enter results manually. You can also enter scores for reading or
            other academic assessments, add diagnostic data from the Skill Library,
            and view grouping recommendations for certain grade levels and time periods.
          </>
        ),
      },
    ],
    []
  );

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!props.isTourShown) {
      setShow(true);
    }
  }, [props.isTourShown]);

  const handleTourChange = (data: CallBackProps) => {
    if (["skip", "reset"].includes(data.action)) {
      props.markEmptyDataPeriodViewTourAsShown();
      setShow(false);
    }
  };

  const { isTeacher, isSupervisor } = useUserRole();

  if (props.isTourShown || isTeacher || isSupervisor) {
    return null;
  }

  return (
    <Joyride
      steps={steps}
      callback={handleTourChange}
      showSkipButton
      floaterProps={{ disableAnimation: true }}
      showProgress
      continuous
      run={show}
      styles={{
        options: {
          primaryColor: "#00265B",
        },
      }}
    />
  );
};

const mapStateToProps = ({ tour }: ApplicationState): StateProps => {
  return {
    isTourShown: tour.emptyDataPeriodViewTourShown,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return bindActionCreators(
    {
      markEmptyDataPeriodViewTourAsShown: markEmptyDataPeriodViewTourAsShown,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmptyDataPeriodViewTour);
